import { FieldArray } from 'formik';

import { useActorsFieldArrayRenderer } from './hooks/useFieldArrayRenderer.hook';
import { actorListKeyOf } from './utils/actor-list.util';
import type { Props } from './types/props.type';

export const FolderBusinessEntityActorsFormStep = (props: Readonly<Props>) => {
  const { isInternal } = props;
  const { fieldArrayRender } = useActorsFieldArrayRenderer(props);

  return (
    <FieldArray name={actorListKeyOf(isInternal)} render={fieldArrayRender} />
  );
};
